import { EEntityScope } from "@/types/common/entityApproval/EntityApproval";
import {
  IScopeFields,
  defaultScopeFields,
} from "@/types/common/entityApproval/EntityScope";

export { defaultScopeFields };

export function withScopeFields<T extends Record<string, unknown>>(
  payload: T,
  scope: IScopeFields
): T & IScopeFields {
  const result = {
    ...payload,
    viewScope: scope.viewScope,
    editScope: scope.editScope,
    viewDirectorateIds:
      scope.viewScope === EEntityScope.MULTI_UNIT
        ? scope.viewDirectorateIds
        : [],
    editDirectorateIds:
      scope.editScope === EEntityScope.MULTI_UNIT
        ? scope.editDirectorateIds
        : [],
    coordinatorId: scope.coordinatorId,
  };
  delete (result as Record<string, unknown>).directorateId;
  return result;
}

export function scopeFromEntity(
  data: Record<string, unknown> | null | undefined
): IScopeFields {
  if (!data) {
    return defaultScopeFields();
  }
  return {
    viewScope: (data.viewScope as EEntityScope) ?? EEntityScope.UNIT,
    editScope: (data.editScope as EEntityScope) ?? EEntityScope.PRIVATE,
    viewDirectorateIds: (data.viewDirectorateIds as string[]) ?? [],
    editDirectorateIds: (data.editDirectorateIds as string[]) ?? [],
    coordinatorId: (data.coordinatorId as string | null) ?? null,
  };
}
